import { render, staticRenderFns } from "./sliderBar.vue?vue&type=template&id=0b880faf&scoped=true&"
import script from "./sliderBar.vue?vue&type=script&lang=ts&"
export * from "./sliderBar.vue?vue&type=script&lang=ts&"
import style0 from "./sliderBar.vue?vue&type=style&index=0&id=0b880faf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b880faf",
  null
  
)

export default component.exports